/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    RESET_title: "Nouveau mot de passe",
    RESET_greeting: "Bonjour {0},",
    RESET_intro: "Choisissez un nouveau mot de passe pour votre compte.",
    RESET_password: "Nouveau mot de passe",
    RESET_passwordPlaceholder: "Votre nouveau mot de passe",
    RESET_confirmPassword: "Confirmer le mot de passe",
    RESET_confirmPasswordPlaceholder: "Confirmez le mot de passe",
    RESET_submit: "Réinitialiser mon mot de passe",
    RESET_loading: "Chargement…",
    RESET_mismatch: "Les mots de passe ne correspondent pas.",
    RESET_invalid: "Ce lien de réinitialisation est invalide ou a expiré.",
    RESET_requestNew: "Demander un nouveau lien",
    RESET_success: "Mot de passe réinitialisé",
    RESET_successMessage: "Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous "
        + "connecter.",
    RESET_goToSignIn: "Se connecter"
};
